import { PostLoginWorkflow } from '@core/sso/models/post-login-workflow.enum';
import { AuthorizationRequest } from '@core/sso/models/open-id-connect/authorization-request.interface';
import { ZendeskLoginRequest } from '@core/sso/models/zendesk/zendesk-login-request.interface';

export type PostLoginActionPayload = null | AuthorizationRequest | string | ZendeskLoginRequest;

export class PostLoginAction {
  public readonly workflow: PostLoginWorkflow;
  public readonly payload: PostLoginActionPayload;

  public static Default = new PostLoginAction(PostLoginWorkflow.Default, null);

  constructor(workflow: PostLoginWorkflow, payloadObj: PostLoginActionPayload) {
    this.workflow = workflow;
    this.payload = payloadObj;
  }
}
